import { useEffect, useRef, useState, useCallback } from "react";

export default function useWebSocket(url, token, maxRetries = 4) {
  const wsRef = useRef(null);
  const retryCount = useRef(0);
  const reconnectTimeout = useRef(null);

  const [isConnected, setIsConnected] = useState(false);
  const [isSeen, setIsSeen] = useState(0);
  const [room, setRoom] = useState(0);
  const [messages, setMessages] = useState([]);
  const sendMessage = useCallback((msg) => {
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(msg));
    } else {
      console.warn("[WS] Cannot send message, socket not open.");
    }
  }, []);
  const joinRoom = useCallback((roomId) => {
    // sendMessage({
    //   action: "join_room",
    //   room_id: roomId,
    // });
    setRoom(roomId)
  }, [sendMessage]);

  // 🆕 Leave a room
  const leaveRoom = useCallback((roomId) => {
    // sendMessage({
    //   action: "leave_room",
    //   room_id: roomId,
    // });
    setRoom(0)
  }, [sendMessage]);
  const connect = useCallback(() => {
    if (retryCount.current >= maxRetries) {
      console.warn("Max reconnect attempts reached. Stopping.");
      return;
    }

    const fullUrl = `${url}?token=${token}`;
    console.log(`[WS] Connecting`);

    wsRef.current = new WebSocket(fullUrl);

    wsRef.current.onopen = () => {
      console.log("[WS] Connected");
      setIsConnected(true);
      retryCount.current = 0; // reset retry count
    };

    wsRef.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("[WS] Message received:", data);
        if (data.event === "seen") {
            console.log(`Message ${data.message_id} seen by ${data.seen_by}`);
            setIsSeen(data.message_id)
            // updateMessageUIAsSeen(data.message_id);
        }else{
            setMessages((prev) => [...prev, data]);

        }
      } catch (err) {
        console.error("Invalid message:", event.data);
      }
    };
    
    wsRef.current.onclose = (e) => {
      console.warn(`[WS] Disconnected. Code=${e.code}`);
      setIsConnected(false);
      leaveRoom(room)
      if (retryCount.current < maxRetries) {
        retryCount.current += 1;
        const delay = 1000 * retryCount.current; // exponential backoff
        console.log(`[WS] Reconnecting in ${delay / 1000}s...`);
        reconnectTimeout.current = setTimeout(connect, delay);
      }
    };

    wsRef.current.onerror = (err) => {
      console.error("[WS] Error:", err);
      wsRef.current.close();
    };
  }, [url, token, maxRetries]);

  
  useEffect(() => {
    connect();
    return () => {
      if (wsRef.current) wsRef.current.close();
      if (reconnectTimeout.current) clearTimeout(reconnectTimeout.current);
    };
  }, [connect]);

  return { isConnected, messages, sendMessage,isSeen,joinRoom,leaveRoom   };
}
